<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de sessiones pendientes"
          icon="fas fa-table"
          @mtdBack="mtdBack"
          :size="'md'"
          :button_new="false"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="false"
          :buttonDelete="false"
          :myButtons="myButtons"
          @mtdGetDetail="mtdGetDetail"
        />
      </CCol>
    </CRow>

    <!-- modal detalle -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'lg'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
    >
      <CRow class="flex">
        <CCol sm="12" xs="12" md="12" lg="12" xl="12">
          <CTabs>
            <CTab
              v-for="(item, index) in sessionData"
              :key="index"
              :title="item.service.name"
              @changeTab="changeTab(index)"
            >
            </CTab>
          </CTabs>
        </CCol>
        <CCol sm="12" xs="12" md="12" lg="12" xl="12" class="mt-2">
          <CRow>
            <CCol sm="12" xs="12" md="4" lg="4" xl="4">
              <h5>SESSIONES ANTERIORES</h5>
              <h4 v-for="(item, index) in selectSession.date" :key="index">
                {{ item.date }}
              </h4>
            </CCol>
            <CCol sm="12" xs="12" md="8" lg="8" xl="8">
              <h5 class="text-center">NUEVA SESSION</h5>
              <CInput type="date" v-model="quote.date" />
              <CInput type="time" v-model="quote.hour" />
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CModalForm>
  </div>
</template>

<script>
const fields = [
  { key: "client_name", label: "Nombre", _style: "width:20%;" },
  { key: "phone", label: "Telefono", _style: "width:10%;" },
  { key: "sale_date", label: "Fecha de primera reserva", _style: "width:5%;" },
];

import { mapActions } from "vuex";
import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import CTab from "../../shared/tab/CTab.vue";
import CTabs from "../../shared/tab/CTabs.vue";

export default {
  name: "c-procces-session-demo",
  components: { CTableWrapper, CModalForm, cModalDelete, CTab, CTabs },
  data() {
    return {
      prefix: "session",
      fields,
      data: [],
      myButtons: [
        {
          class: "btn-sm",
          color: "info",
          tooltip: "VER SESSIONES",
          action: "mtdGetDetail",
          icon: "fas fa-eye",
        },
      ],
      modal: {
        action: "",
        title: "SESSIONES",
        modal_form: false,
      },
      activeTab: null,
      sessionData: [],
      selectSession: [],
      quote: {
        date: null,
        hour: null,
        sale_id: null,
        quote_id: null,
        service_id: null,
        client_name: "",
        quote_session:null
      },
    };
  },
  computed: {
    cp_button() {
      if (this.quote.date != null && this.quote.hour != null) return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdBack: function () {
      this.$emit("returnHome");
    },
    mtdGetDetail: function (payload) {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/getDetail",
        params: payload,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.modal.modal_form = true;
          this.sessionData = response.data.det;
          this.changeTab(0);
          this.quote.sale_id = payload.sale_id;
          this.quote.client_name = payload.client_name;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_action: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        params: this.quote,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.quote = {
              date: null,
              hour: null,
              sale_id: null,
              quote_id: null,
              service_id: null,
              client_name: "",
              quote_session:null
            };
            Swal.fire({
              title: "SESSION REGISTRADA!!",
              icon: "success",
            });
            this.modal= {
              title: "SESSIONES",
              modal_form: false,
            };
            this.activeTab= null;
            this.sessionData= [];
            this.selectSession= [];
            this.mtd_getdata();
          } else {
          }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    changeTab: function (pos) {
      this.selectSession = this.sessionData[pos];
      this.quote.quote_id = this.selectSession.quote_id;
      this.quote.service_id = this.selectSession.service_id;
      this.quote.service_name = this.selectSession.service.name;
      this.quote.quote_session = this.selectSession.id;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>